var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',[_c('profile-data-table',{attrs:{"title":_vm.$t('Asesores'),"profile":"consultant"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }